<template lang="pug">
  .component-attributes
    .attributes-list
      .row
        .columns
          .input-group

            selectize-vehicle-attribute.input-group-field(@optionSelected="updateAttributes")
            .input-group-button
              button.button.fa.fa-plus(@click="addAttribute")

      //loading-spinner(v-if="addInProgress")
    .container

      .prop-item(v-for="(attribute, index) in value")
        .input-group
          span.input-group-label {{attribute.name}}
          input.input-group-field(type='text', v-model="attribute.value")
          .input-group-button
            button.button.default.save(:disabled="value[index].value == null || value[index].value == '' || disabled || spin ", @click="saveAttribute(attribute)")
              span.fa.fa-spinner.fa-spin(v-if="spin", :class="{spin:spin}")
              span.fa.fa-save(v-else)
            button.button.warning.fa(@click="removeAttribute(index)", :disabled="disabled || spin")
              span.fa.fa-spinner.fa-spin(v-if="spin", :class="{spin:spin}")
              span.fa.fa-times(v-else)
</template>

<script>
import ActionBar from "../../structure/ui/ActionBar";
import SelectizeVehicleAttribute from "../../structure/ui/lists/selectize/SelectizeVehicleAttribute";
import LoadingSpinner from "../../structure/LoadingSpinner";

export default {
  name: "Attributes",
  components: {LoadingSpinner, SelectizeVehicleAttribute, ActionBar},
  data() {
    return {
      tempAttribute: null,
      spin: false,
      disabled: false
    }
  },
  methods: {
    addAttribute() {
      let temp = this.value
      temp.push(this.tempAttribute)
      this.$emit('input', temp)
      this.tempAttribute = null
    },
    updateAttributes(obj) {
      this.tempAttribute = {
        id: null,
        attribute_id: obj.id,
        name: obj.name,
        value: null,
      }
    },
    saveAttribute(attribute) {
      this.$emit('updateAttribute', attribute)
      if (this.saveAction != null) {
        this.disabled = true
        this.spin = true
        this.saveAction(attribute).then(() => {
          this.disabled = false
          this.spin = false
        })
      }
    },
    removeAttribute(index) {

      this.$confirm('Are you sure?', 'Do you want to delete this attribute?', () => {
        if (this.value[index].id) {
          this.$emit('deleteAttribute', this.value[index])
        }

        if (this.deleteAction != null && this.value[index].id != null) {
          this.disabled = true
          this.spin = true
          this.deleteAction(this.value[index]).then(() => {
            this.disabled = false
            this.spin = false
            let temp = this.value
            temp.splice(index, 1)
          })
          return
        }

        let temp = this.value
        temp.splice(index, 1)


      })
    }
  },

  props: ['value', 'saveAction', 'deleteAction'],
}
</script>

<style lang="sass">
.component-attributes
  .save
    border-radius: 0
</style>



// WEBPACK FOOTER //
// Attributes.vue?4d06afca